import React, { useEffect } from 'react';

import queryString from 'query-string';
import { useSearchBox } from 'react-instantsearch-core';
import { useTranslation } from 'react-i18next';
import config from 'react-global-configuration';
import {
  SearchBar as DefaultSearchBar,
} from '@uncinc/react-searchkit';

import { APP_OPTIONS } from '../../../config/constants';

import './style.scss';

const SearchBar = (props) => {
  const { t } = useTranslation();
  const {
    query,
    refine,
  } = useSearchBox(props);
  const params = queryString.parse(window.location.search);
  const currentDomain = config.get('CURRENT_DOMAIN');

  // Set the new query if it was changed via the KP Header.
  useEffect(() => {
    if (currentDomain === 'kp') {
      const newQuery = params[`${APP_OPTIONS.parameters.searchkitIndexAllContent}[query]`];

      if (newQuery && query !== newQuery) {
        refine(newQuery);
      }
    }
  }, [window.location.search, currentDomain]);

  return (
    <div className="SearchBar" id="SearchBar">
      <div className="SearchBar__icon_search">
        <i className="icon icon-search icon-variant-2" />
      </div>
      <DefaultSearchBar
        searchAsYouType
        buttonText={<>{t('search.buttonText')} <i className="icon icon-arrow-right icon-variant-4" /></>}
        placeholder={t('search.placeholder')}
      />
    </div>
  );
};

export default SearchBar;
